import type React from 'react';

import { TextField } from '@mui/material';

import { useConsultation } from '@src/entities/consultations';

import { ModalSmall } from 'library/components/common';

import { usePrepaid } from './model';
import * as st from './styles.module.scss';

type Props = {
	id: number;
};

export const ConsultationCost: React.FC<Props> = ({ id }) => {
	const { consultation } = useConsultation(id);

	return <>{consultation && `${consultation.cost.amount / 100} ₽`}</>;
};

interface DebtProps {
	id: number;
	onClick: () => void;
}

export const Debt: React.FC<DebtProps> = ({ id, onClick }) => {
	const { consultation } = useConsultation(id);

	return (
		<div className={st.debt}>
			<div className={st.debt__text}>
				{consultation &&
					`${consultation.cost?.full_cost - consultation.cost?.amount - consultation.payments} ₽`}
			</div>

			<button className={st.debt__btn} onClick={onClick}>
				Внести
			</button>
		</div>
	);
};

type ModalPrepaidProps = {
	id: number;
	isOpen: boolean;
	toggle: () => void;
};

export const ModalPrepaid: React.FC<ModalPrepaidProps> = ({ id, isOpen, toggle }) => {
	const { amount, setAmount, onPay } = usePrepaid(id);

	return (
		<ModalSmall isOpen={isOpen} onRequestClose={toggle} title="Укажите сумму">
			<div style={{ display: 'flex', alignItems: 'center', flexGrow: 1, padding: '20px' }}>
				<TextField
					fullWidth
					value={amount}
					onChange={(e) => setAmount(e.target.value)}
					size="small"
					label="Укажите сумму"
				/>
				<button
					style={{
						backgroundColor: '#4198c5',
						color: '#fff',
						flex: '0 0 100px',
						height: '40px',
						borderRadius: '4px',
						marginLeft: '10px',
					}}
					onClick={() => {
						onPay();
						toggle();
					}}
				>
					Внести
				</button>
			</div>
		</ModalSmall>
	);
};
